module.exports = __webpack_public_path__ + "img/hud_right_btm_corn.592eea06.png";